import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { mdiPencil } from '@mdi/js';
import { AdminErrorMessagesVM } from './AdminErrorMessagesVM';
import { InputSearch } from 'cd-eft/components/common/InputSearch';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'cd-eft/utils/formatDate';
import { Table } from 'reactstrap';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { mdiPlusCircle } from '@mdi/js';
import Icon from '@mdi/react';
import './AdminErrorMessages.scss';

export const AdminErrorMessages = observer(() => {
  const vm = useRef(new AdminErrorMessagesVM()).current;

  useEffect(() => {
    vm.getAllErrorHandlings();
  }, []);

  return (
    <div className="admin-content">
      {vm.isLoading && <Loader message="Loading Error List..." />}

      <h1>Admin : Error Messages</h1>

      <div className="usa-card__container m-0 flex-fill">
        <div className="usa-card__header primary-card-header justify-content-start">
          <h2>NETS Error Messages</h2>
          <Link to="/admin/error-messages/add-new" className="usa-button usa-button--outline white-btn mx-3 py-1 px-2">
            <Icon path={mdiPlusCircle} size={1} /> Add
          </Link>
        </div>

        <div className="d-flex justify-content-between m-3">
          <InputSearch
            name="search_error_text_value"
            setSearchValue={vm.onChangeSearchInput}
            searchString={vm.searchValue}
            placeholder="Search by Error Code #"
          />
        </div>

        <div className="admin-error-container flex-fill">
          <div className="usa-table-container--scrollable">
            <Table className="usa-table usa-table--borderless set-table">
              <thead>
                <tr>
                  <th scope="col" className="pl-3">
                    Error Code
                  </th>
                  <th scope="col">Error Category</th>
                  <th scope="col">Error Description</th>
                  <th scope="col">Error Details</th>
                  <th scope="col">Last Updated</th>
                </tr>
              </thead>

              <tbody>
                {vm.filteredErrorData &&
                  vm.filteredErrorData.map((item) => (
                    <tr key={`error-message-${item.errorCodeLUTId}`}>
                      <td className="pl-3 nobr">
                        <Link
                          className="usa-button--unstyled display-block"
                          to={`/admin/error-messages/${item.originalErrorCode}`}
                        >
                          <Icon path={mdiPencil} size={1} /> {item.errorCode}
                        </Link>
                      </td>
                      <td>{item.errorCategoryCode}</td>
                      <td>{item.errorShortDescription}</td>
                      <td>{item.errorDetails}</td>
                      <td>
                        {item.lastChangedBy} {formatDateTime(item.lastChangeDate)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
});
